import type { JsonBody, SuccessResponse } from './openapi-helpers';
import type { components, paths } from './openapi-schema';

export const CREATE_BUSINESS_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESSES_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_APPOINTMENTS_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/appointments',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_APPOINTMENT_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/appointments',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_APPOINTMENT_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/appointments/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const DELETE_BUSINESS_APPOINTMENT_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/appointments/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CHECK_BUSINESS_APPOINTMENT_OVERLAP_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/appointments/check_overlap',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_BREAKS_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/breaks',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_BREAK_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/breaks',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_BREAK_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/breaks/{kind}/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const DELETE_BUSINESS_BREAK_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/breaks/{kind}/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_CLIENTS_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/clients',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_DASHBOARD_METRICS_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/dashboard/metrics',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_DASHBOARD_COMMUNICATIONS_REPORT_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/dashboard/communications_report',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_LOYALTY_PROGRAMS_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/loyalty_programs',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_LOYALTY_PROGRAM_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/loyalty_programs',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_LOYALTY_PROGRAM_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/loyalty_programs/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const ARCHIVE_BUSINESS_LOYALTY_PROGRAM_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/loyalty_programs/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_CLIENT_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/clients/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_CLIENT_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/clients',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_CLIENT_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/clients/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const DELETE_BUSINESS_CLIENT_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/clients/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const RESTORE_BUSINESS_CLIENT_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/clients/{id}/restore',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_STAFF_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/staff',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_STAFF_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/staff',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_STAFF_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/staff/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_STAFF_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/staff/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const DELETE_BUSINESS_STAFF_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/staff/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const RESTORE_BUSINESS_STAFF_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/staff/{id}/restore',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_SERVICES_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/services',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_SERVICE_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/services',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_SERVICE_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/services/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_SERVICE_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/services/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const DELETE_BUSINESS_SERVICE_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/services/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const RESTORE_BUSINESS_SERVICE_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/services/{id}/restore',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_AVAILABILITIES_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/availabilities',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const LIST_BUSINESS_SPACES_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/spaces',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_SPACE_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/spaces',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_SPACE_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/spaces/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_SPACE_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/spaces/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const ARCHIVE_BUSINESS_SPACE_OPERATION = {
  method: 'delete',
  path: '/api/v1/businesses/{business_id}/spaces/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const RESTORE_BUSINESS_SPACE_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/spaces/{id}/restore',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const GET_BUSINESS_CALENDAR_PREFERENCES_OPERATION = {
  method: 'get',
  path: '/api/v1/businesses/{business_id}/calendar/preferences',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_CALENDAR_PREFERENCES_OPERATION = {
  method: 'put',
  path: '/api/v1/businesses/{business_id}/calendar/preferences',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const CREATE_BUSINESS_AVAILABILITY_OPERATION = {
  method: 'post',
  path: '/api/v1/businesses/{business_id}/availabilities',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

export const UPDATE_BUSINESS_AVAILABILITY_OPERATION = {
  method: 'patch',
  path: '/api/v1/businesses/{business_id}/availabilities/{id}',
  source: 'http://localhost:3000/api-docs/v1/swagger.json',
} as const;

type ListBusinessStaffOperation =
  paths[typeof LIST_BUSINESS_STAFF_OPERATION.path][typeof LIST_BUSINESS_STAFF_OPERATION.method];
type CreateBusinessStaffOperation =
  paths[typeof CREATE_BUSINESS_STAFF_OPERATION.path][typeof CREATE_BUSINESS_STAFF_OPERATION.method];
type GetBusinessStaffOperation =
  paths[typeof GET_BUSINESS_STAFF_OPERATION.path][typeof GET_BUSINESS_STAFF_OPERATION.method];
type UpdateBusinessStaffOperation =
  paths[typeof UPDATE_BUSINESS_STAFF_OPERATION.path][typeof UPDATE_BUSINESS_STAFF_OPERATION.method];
type DeleteBusinessStaffOperation =
  paths[typeof DELETE_BUSINESS_STAFF_OPERATION.path][typeof DELETE_BUSINESS_STAFF_OPERATION.method];
type RestoreBusinessStaffOperation =
  paths[typeof RESTORE_BUSINESS_STAFF_OPERATION.path][typeof RESTORE_BUSINESS_STAFF_OPERATION.method];
type ListBusinessServicesOperation =
  paths[typeof LIST_BUSINESS_SERVICES_OPERATION.path][typeof LIST_BUSINESS_SERVICES_OPERATION.method];
type CreateBusinessServiceOperation =
  paths[typeof CREATE_BUSINESS_SERVICE_OPERATION.path][typeof CREATE_BUSINESS_SERVICE_OPERATION.method];
type GetBusinessServiceOperation =
  paths[typeof GET_BUSINESS_SERVICE_OPERATION.path][typeof GET_BUSINESS_SERVICE_OPERATION.method];
type UpdateBusinessServiceOperation =
  paths[typeof UPDATE_BUSINESS_SERVICE_OPERATION.path][typeof UPDATE_BUSINESS_SERVICE_OPERATION.method];
type DeleteBusinessServiceOperation =
  paths[typeof DELETE_BUSINESS_SERVICE_OPERATION.path][typeof DELETE_BUSINESS_SERVICE_OPERATION.method];
type RestoreBusinessServiceOperation =
  paths[typeof RESTORE_BUSINESS_SERVICE_OPERATION.path][typeof RESTORE_BUSINESS_SERVICE_OPERATION.method];
type ListBusinessAvailabilitiesOperation =
  paths[typeof LIST_BUSINESS_AVAILABILITIES_OPERATION.path][typeof LIST_BUSINESS_AVAILABILITIES_OPERATION.method];
type CreateBusinessAvailabilityOperation =
  paths[typeof CREATE_BUSINESS_AVAILABILITY_OPERATION.path][typeof CREATE_BUSINESS_AVAILABILITY_OPERATION.method];
type UpdateBusinessAvailabilityOperation =
  paths[typeof UPDATE_BUSINESS_AVAILABILITY_OPERATION.path][typeof UPDATE_BUSINESS_AVAILABILITY_OPERATION.method];
type ListBusinessSpacesOperation =
  paths[typeof LIST_BUSINESS_SPACES_OPERATION.path][typeof LIST_BUSINESS_SPACES_OPERATION.method];
type CreateBusinessSpaceOperation =
  paths[typeof CREATE_BUSINESS_SPACE_OPERATION.path][typeof CREATE_BUSINESS_SPACE_OPERATION.method];
type GetBusinessSpaceOperation =
  paths[typeof GET_BUSINESS_SPACE_OPERATION.path][typeof GET_BUSINESS_SPACE_OPERATION.method];
type UpdateBusinessSpaceOperation =
  paths[typeof UPDATE_BUSINESS_SPACE_OPERATION.path][typeof UPDATE_BUSINESS_SPACE_OPERATION.method];
type ArchiveBusinessSpaceOperation =
  paths[typeof ARCHIVE_BUSINESS_SPACE_OPERATION.path][typeof ARCHIVE_BUSINESS_SPACE_OPERATION.method];
type RestoreBusinessSpaceOperation =
  paths[typeof RESTORE_BUSINESS_SPACE_OPERATION.path][typeof RESTORE_BUSINESS_SPACE_OPERATION.method];
type GetBusinessCalendarPreferencesOperation =
  paths[typeof GET_BUSINESS_CALENDAR_PREFERENCES_OPERATION.path][typeof GET_BUSINESS_CALENDAR_PREFERENCES_OPERATION.method];
type UpdateBusinessCalendarPreferencesOperation =
  paths[typeof UPDATE_BUSINESS_CALENDAR_PREFERENCES_OPERATION.path][typeof UPDATE_BUSINESS_CALENDAR_PREFERENCES_OPERATION.method];

type ListBusinessesOperation =
  paths[typeof LIST_BUSINESSES_OPERATION.path][typeof LIST_BUSINESSES_OPERATION.method];
type CreateBusinessOperation =
  paths[typeof CREATE_BUSINESS_OPERATION.path][typeof CREATE_BUSINESS_OPERATION.method];
type GetBusinessOperation =
  paths[typeof GET_BUSINESS_OPERATION.path][typeof GET_BUSINESS_OPERATION.method];
type UpdateBusinessOperation =
  paths[typeof UPDATE_BUSINESS_OPERATION.path][typeof UPDATE_BUSINESS_OPERATION.method];
type ListBusinessAppointmentsOperation =
  paths[typeof LIST_BUSINESS_APPOINTMENTS_OPERATION.path][typeof LIST_BUSINESS_APPOINTMENTS_OPERATION.method];
type CreateBusinessAppointmentOperation =
  paths[typeof CREATE_BUSINESS_APPOINTMENT_OPERATION.path][typeof CREATE_BUSINESS_APPOINTMENT_OPERATION.method];
type UpdateBusinessAppointmentOperation =
  paths[typeof UPDATE_BUSINESS_APPOINTMENT_OPERATION.path][typeof UPDATE_BUSINESS_APPOINTMENT_OPERATION.method];
type DeleteBusinessAppointmentOperation =
  paths[typeof DELETE_BUSINESS_APPOINTMENT_OPERATION.path][typeof DELETE_BUSINESS_APPOINTMENT_OPERATION.method];
type ListBusinessBreaksOperation =
  paths[typeof LIST_BUSINESS_BREAKS_OPERATION.path][typeof LIST_BUSINESS_BREAKS_OPERATION.method];
type CreateBusinessBreakOperation =
  paths[typeof CREATE_BUSINESS_BREAK_OPERATION.path][typeof CREATE_BUSINESS_BREAK_OPERATION.method];
type UpdateBusinessBreakOperation =
  paths[typeof UPDATE_BUSINESS_BREAK_OPERATION.path][typeof UPDATE_BUSINESS_BREAK_OPERATION.method];
type DeleteBusinessBreakOperation =
  paths[typeof DELETE_BUSINESS_BREAK_OPERATION.path][typeof DELETE_BUSINESS_BREAK_OPERATION.method];
type ListBusinessClientsOperation =
  paths[typeof LIST_BUSINESS_CLIENTS_OPERATION.path][typeof LIST_BUSINESS_CLIENTS_OPERATION.method];
type GetBusinessDashboardMetricsOperation =
  paths[typeof GET_BUSINESS_DASHBOARD_METRICS_OPERATION.path][typeof GET_BUSINESS_DASHBOARD_METRICS_OPERATION.method];
type GetBusinessDashboardCommunicationsReportOperation =
  paths[typeof GET_BUSINESS_DASHBOARD_COMMUNICATIONS_REPORT_OPERATION.path][typeof GET_BUSINESS_DASHBOARD_COMMUNICATIONS_REPORT_OPERATION.method];
type ListBusinessLoyaltyProgramsOperation =
  paths[typeof LIST_BUSINESS_LOYALTY_PROGRAMS_OPERATION.path][typeof LIST_BUSINESS_LOYALTY_PROGRAMS_OPERATION.method];
type CreateBusinessLoyaltyProgramOperation =
  paths[typeof CREATE_BUSINESS_LOYALTY_PROGRAM_OPERATION.path][typeof CREATE_BUSINESS_LOYALTY_PROGRAM_OPERATION.method];
type UpdateBusinessLoyaltyProgramOperation =
  paths[typeof UPDATE_BUSINESS_LOYALTY_PROGRAM_OPERATION.path][typeof UPDATE_BUSINESS_LOYALTY_PROGRAM_OPERATION.method];
type ArchiveBusinessLoyaltyProgramOperation =
  paths[typeof ARCHIVE_BUSINESS_LOYALTY_PROGRAM_OPERATION.path][typeof ARCHIVE_BUSINESS_LOYALTY_PROGRAM_OPERATION.method];
type GetBusinessClientOperation =
  paths[typeof GET_BUSINESS_CLIENT_OPERATION.path][typeof GET_BUSINESS_CLIENT_OPERATION.method];
type CreateBusinessClientOperation =
  paths[typeof CREATE_BUSINESS_CLIENT_OPERATION.path][typeof CREATE_BUSINESS_CLIENT_OPERATION.method];
type UpdateBusinessClientOperation =
  paths[typeof UPDATE_BUSINESS_CLIENT_OPERATION.path][typeof UPDATE_BUSINESS_CLIENT_OPERATION.method];
type DeleteBusinessClientOperation =
  paths[typeof DELETE_BUSINESS_CLIENT_OPERATION.path][typeof DELETE_BUSINESS_CLIENT_OPERATION.method];
type RestoreBusinessClientOperation =
  paths[typeof RESTORE_BUSINESS_CLIENT_OPERATION.path][typeof RESTORE_BUSINESS_CLIENT_OPERATION.method];

type ListBusinessAvailabilitiesSuccessResponse = ListBusinessAvailabilitiesOperation['responses'][200];
type CreateBusinessAvailabilityRequestBody = CreateBusinessAvailabilityOperation['requestBody'];
type CreateBusinessAvailabilityResponses = Pick<CreateBusinessAvailabilityOperation['responses'], 201>;
type UpdateBusinessAvailabilityRequestBody = UpdateBusinessAvailabilityOperation['requestBody'];
type UpdateBusinessAvailabilityResponses = Pick<UpdateBusinessAvailabilityOperation['responses'], 200>;

type ListBusinessSpacesSuccessResponse = ListBusinessSpacesOperation['responses'][200];
type CreateBusinessSpaceRequestBody = CreateBusinessSpaceOperation['requestBody'];
type CreateBusinessSpaceResponses = Pick<CreateBusinessSpaceOperation['responses'], 201>;
type GetBusinessSpaceResponses = Pick<GetBusinessSpaceOperation['responses'], 200>;
type UpdateBusinessSpaceRequestBody = UpdateBusinessSpaceOperation['requestBody'];
type UpdateBusinessSpaceResponses = Pick<UpdateBusinessSpaceOperation['responses'], 200>;
type RestoreBusinessSpaceResponses = Pick<RestoreBusinessSpaceOperation['responses'], 200>;
type GetBusinessCalendarPreferencesResponses = Pick<GetBusinessCalendarPreferencesOperation['responses'], 200>;
type UpdateBusinessCalendarPreferencesRequestBody = UpdateBusinessCalendarPreferencesOperation['requestBody'];
type UpdateBusinessCalendarPreferencesResponses = Pick<UpdateBusinessCalendarPreferencesOperation['responses'], 200>;

type ListBusinessesSuccessResponse = ListBusinessesOperation['responses'][200];
type CreateBusinessRequestBody = CreateBusinessOperation['requestBody'];
type GetBusinessResponses = Pick<GetBusinessOperation['responses'], 200>;
type UpdateBusinessRequestBody = UpdateBusinessOperation['requestBody'];
type UpdateBusinessResponses = Pick<UpdateBusinessOperation['responses'], 200>;
type ListBusinessAppointmentsSuccessResponse =
  ListBusinessAppointmentsOperation['responses'][200];
type CreateBusinessAppointmentRequestBody =
  CreateBusinessAppointmentOperation['requestBody'];
type CreateBusinessAppointmentResponses = Pick<CreateBusinessAppointmentOperation['responses'], 201>;
type UpdateBusinessAppointmentRequestBody =
  UpdateBusinessAppointmentOperation['requestBody'];
type UpdateBusinessAppointmentResponses = Pick<UpdateBusinessAppointmentOperation['responses'], 200>;
type ListBusinessBreaksSuccessResponse = ListBusinessBreaksOperation['responses'][200];
type CreateBusinessBreakRequestBody = CreateBusinessBreakOperation['requestBody'];
type CreateBusinessBreakResponses = Pick<CreateBusinessBreakOperation['responses'], 201>;
type UpdateBusinessBreakRequestBody = UpdateBusinessBreakOperation['requestBody'];
type UpdateBusinessBreakResponses = Pick<UpdateBusinessBreakOperation['responses'], 200>;
type ListBusinessClientsSuccessResponse =
  ListBusinessClientsOperation['responses'][200];
type GetBusinessDashboardMetricsResponses = Pick<
  GetBusinessDashboardMetricsOperation['responses'],
  200
>;
type GetBusinessDashboardCommunicationsReportResponses = Pick<
  GetBusinessDashboardCommunicationsReportOperation['responses'],
  200
>;
type ListBusinessLoyaltyProgramsSuccessResponse =
  ListBusinessLoyaltyProgramsOperation['responses'][200];
type CreateBusinessLoyaltyProgramRequestBody =
  CreateBusinessLoyaltyProgramOperation['requestBody'];
type CreateBusinessLoyaltyProgramResponses = Pick<
  CreateBusinessLoyaltyProgramOperation['responses'],
  201
>;
type UpdateBusinessLoyaltyProgramRequestBody =
  UpdateBusinessLoyaltyProgramOperation['requestBody'];
type UpdateBusinessLoyaltyProgramResponses = Pick<
  UpdateBusinessLoyaltyProgramOperation['responses'],
  200
>;
type GetBusinessClientResponses = Pick<GetBusinessClientOperation['responses'], 200>;
type CreateBusinessClientRequestBody =
  CreateBusinessClientOperation['requestBody'];
type CreateBusinessClientResponses = Pick<CreateBusinessClientOperation['responses'], 201>;
type UpdateBusinessClientRequestBody =
  UpdateBusinessClientOperation['requestBody'];
type UpdateBusinessClientResponses = Pick<UpdateBusinessClientOperation['responses'], 200>;
type RestoreBusinessClientResponses = Pick<RestoreBusinessClientOperation['responses'], 200>;
type ListBusinessStaffSuccessResponse = ListBusinessStaffOperation['responses'][200];
type CreateBusinessStaffRequestBody = CreateBusinessStaffOperation['requestBody'];
type CreateBusinessStaffResponses = Pick<CreateBusinessStaffOperation['responses'], 201>;
type GetBusinessStaffResponses = Pick<GetBusinessStaffOperation['responses'], 200>;
type UpdateBusinessStaffRequestBody = UpdateBusinessStaffOperation['requestBody'];
type UpdateBusinessStaffResponses = Pick<UpdateBusinessStaffOperation['responses'], 200>;
type RestoreBusinessStaffResponses = Pick<RestoreBusinessStaffOperation['responses'], 200>;
type ListBusinessServicesSuccessResponse =
  ListBusinessServicesOperation['responses'][200];
type CreateBusinessServiceRequestBody =
  CreateBusinessServiceOperation['requestBody'];
type CreateBusinessServiceResponses =
  Pick<CreateBusinessServiceOperation['responses'], 201>;
type GetBusinessServiceResponses = Pick<GetBusinessServiceOperation['responses'], 200>;
type UpdateBusinessServiceRequestBody =
  UpdateBusinessServiceOperation['requestBody'];
type UpdateBusinessServiceResponses =
  Pick<UpdateBusinessServiceOperation['responses'], 200>;
type RestoreBusinessServiceResponses =
  Pick<RestoreBusinessServiceOperation['responses'], 200>;

export type GeneratedCreateBusinessRequest = JsonBody<CreateBusinessRequestBody>;
export type GeneratedAccessibleBusiness = components['schemas']['AccessibleBusiness'];
export type GeneratedListBusinessesResponse =
  JsonBody<ListBusinessesSuccessResponse>;
// The current schema still defines BusinessResponse but omits the create success code.
export type GeneratedCreateBusinessResponse = components['schemas']['BusinessResponse'];
export type GeneratedGetBusinessResponse = SuccessResponse<GetBusinessResponses>;
export type GeneratedUpdateBusinessRequest = JsonBody<UpdateBusinessRequestBody>;
export type GeneratedUpdateBusinessResponse =
  SuccessResponse<UpdateBusinessResponses>;
export type GeneratedListBusinessAppointmentsQuery =
  NonNullable<ListBusinessAppointmentsOperation['parameters']['query']>;
export type GeneratedListBusinessAppointmentsResponse =
  JsonBody<ListBusinessAppointmentsSuccessResponse>;
export type GeneratedBusinessClient = components['schemas']['Client'];
export type GeneratedListBusinessClientsQuery =
  NonNullable<ListBusinessClientsOperation['parameters']['query']>;
export type GeneratedListBusinessClientsResponse =
  JsonBody<ListBusinessClientsSuccessResponse>;
export type GeneratedGetBusinessDashboardMetricsQuery =
  NonNullable<GetBusinessDashboardMetricsOperation['parameters']['query']>;
export type GeneratedGetBusinessDashboardMetricsResponse =
  SuccessResponse<GetBusinessDashboardMetricsResponses>;
export type GeneratedGetBusinessDashboardCommunicationsReportQuery =
  NonNullable<GetBusinessDashboardCommunicationsReportOperation['parameters']['query']>;
export type GeneratedGetBusinessDashboardCommunicationsReportResponse =
  SuccessResponse<GetBusinessDashboardCommunicationsReportResponses>;
export type GeneratedLoyaltyProgram = components['schemas']['LoyaltyProgram'];
export type GeneratedListBusinessLoyaltyProgramsResponse =
  JsonBody<ListBusinessLoyaltyProgramsSuccessResponse>;
export type GeneratedCreateBusinessLoyaltyProgramRequest =
  JsonBody<CreateBusinessLoyaltyProgramRequestBody>;
export type GeneratedCreateBusinessLoyaltyProgramResponse =
  SuccessResponse<CreateBusinessLoyaltyProgramResponses>;
export type GeneratedUpdateBusinessLoyaltyProgramRequest =
  JsonBody<UpdateBusinessLoyaltyProgramRequestBody>;
export type GeneratedUpdateBusinessLoyaltyProgramResponse =
  SuccessResponse<UpdateBusinessLoyaltyProgramResponses>;
export type GeneratedArchiveBusinessLoyaltyProgramResponse =
  ArchiveBusinessLoyaltyProgramOperation['responses'][204];
export type GeneratedGetBusinessClientResponse =
  SuccessResponse<GetBusinessClientResponses>;
export type GeneratedGetBusinessClientProfileResponse =
  GeneratedGetBusinessClientResponse;
export type GeneratedCreateBusinessClientRequest =
  JsonBody<CreateBusinessClientRequestBody>;
export type GeneratedCreateBusinessClientResponse =
  SuccessResponse<CreateBusinessClientResponses>;
export type GeneratedUpdateBusinessClientRequest =
  JsonBody<UpdateBusinessClientRequestBody>;
export type GeneratedUpdateBusinessClientResponse =
  SuccessResponse<UpdateBusinessClientResponses>;
export type GeneratedDeleteBusinessClientResponse =
  DeleteBusinessClientOperation['responses'][204];
export type GeneratedRestoreBusinessClientResponse =
  SuccessResponse<RestoreBusinessClientResponses>;
export type GeneratedCreateAppointmentRequest =
  JsonBody<CreateBusinessAppointmentRequestBody>;
export type GeneratedCreateAppointmentResponse =
  SuccessResponse<CreateBusinessAppointmentResponses>;
export type GeneratedUpdateAppointmentRequest =
  JsonBody<UpdateBusinessAppointmentRequestBody>;
export type GeneratedUpdateAppointmentResponse =
  SuccessResponse<UpdateBusinessAppointmentResponses>;
export type GeneratedDeleteAppointmentResponse =
  DeleteBusinessAppointmentOperation['responses'][204];
// The check_overlap endpoint is not described in the Swagger source, so its
// request/response types are authored here following the appointment shapes.
export type GeneratedCheckAppointmentOverlapRequest = {
  appointment: NonNullable<GeneratedCreateAppointmentRequest['appointment']>;
  client?: GeneratedCreateAppointmentRequest['client'];
  appointment_id?: number;
};
export type GeneratedCheckAppointmentOverlapResponse = {
  allow_overlap: boolean;
  conflicts: {
    appointment_id: number;
    staff_id: number;
    starts_at: string;
    ends_at: string;
  }[];
};
export type GeneratedOverlapConflict =
  GeneratedCheckAppointmentOverlapResponse['conflicts'][number];
export type GeneratedBreak = components['schemas']['Break'];
export type GeneratedBreakKind = GeneratedBreak['kind'];
export type GeneratedListBusinessBreaksResponse =
  JsonBody<ListBusinessBreaksSuccessResponse>;
export type GeneratedCreateBusinessBreakRequest =
  JsonBody<CreateBusinessBreakRequestBody>;
export type GeneratedCreateBusinessBreakResponse =
  SuccessResponse<CreateBusinessBreakResponses>;
export type GeneratedUpdateBusinessBreakRequest =
  JsonBody<UpdateBusinessBreakRequestBody>;
export type GeneratedUpdateBusinessBreakResponse =
  SuccessResponse<UpdateBusinessBreakResponses>;
export type GeneratedDeleteBusinessBreakResponse =
  DeleteBusinessBreakOperation['responses'][204];
export type GeneratedStaff = components['schemas']['Staff'];
export type GeneratedListBusinessStaffQuery =
  NonNullable<ListBusinessStaffOperation['parameters']['query']>;
export type GeneratedListBusinessStaffResponse =
  JsonBody<ListBusinessStaffSuccessResponse>;
export type GeneratedCreateBusinessStaffRequest =
  JsonBody<CreateBusinessStaffRequestBody>;
export type GeneratedCreateBusinessStaffResponse =
  SuccessResponse<CreateBusinessStaffResponses>;
export type GeneratedGetBusinessStaffResponse =
  SuccessResponse<GetBusinessStaffResponses>;
export type GeneratedUpdateBusinessStaffRequest =
  JsonBody<UpdateBusinessStaffRequestBody>;
export type GeneratedUpdateBusinessStaffResponse =
  SuccessResponse<UpdateBusinessStaffResponses>;
export type GeneratedDeleteBusinessStaffResponse =
  DeleteBusinessStaffOperation['responses'][204];
export type GeneratedRestoreBusinessStaffResponse =
  SuccessResponse<RestoreBusinessStaffResponses>;
export type GeneratedService = components['schemas']['Service'];
export type GeneratedListBusinessServicesQuery =
  NonNullable<ListBusinessServicesOperation['parameters']['query']>;
export type GeneratedListBusinessServicesResponse =
  JsonBody<ListBusinessServicesSuccessResponse>;
export type GeneratedCreateBusinessServiceRequest =
  JsonBody<CreateBusinessServiceRequestBody>;
export type GeneratedCreateBusinessServiceResponse =
  SuccessResponse<CreateBusinessServiceResponses>;
export type GeneratedGetBusinessServiceResponse =
  SuccessResponse<GetBusinessServiceResponses>;
export type GeneratedUpdateBusinessServiceRequest =
  JsonBody<UpdateBusinessServiceRequestBody>;
export type GeneratedUpdateBusinessServiceResponse =
  SuccessResponse<UpdateBusinessServiceResponses>;
export type GeneratedDeleteBusinessServiceResponse =
  DeleteBusinessServiceOperation['responses'][204];
export type GeneratedRestoreBusinessServiceResponse =
  SuccessResponse<RestoreBusinessServiceResponses>;
export type GeneratedAvailability = components['schemas']['Availability'];
export type GeneratedListBusinessAvailabilitiesResponse =
  JsonBody<ListBusinessAvailabilitiesSuccessResponse>;
export type GeneratedCreateBusinessAvailabilityRequest =
  JsonBody<CreateBusinessAvailabilityRequestBody>;
export type GeneratedCreateBusinessAvailabilityResponse =
  SuccessResponse<CreateBusinessAvailabilityResponses>;
export type GeneratedUpdateBusinessAvailabilityRequest =
  JsonBody<UpdateBusinessAvailabilityRequestBody>;
export type GeneratedUpdateBusinessAvailabilityResponse =
  SuccessResponse<UpdateBusinessAvailabilityResponses>;
export type GeneratedSpace = components['schemas']['Space'];
export type GeneratedListBusinessSpacesResponse =
  JsonBody<ListBusinessSpacesSuccessResponse>;
export type GeneratedCreateBusinessSpaceRequest =
  JsonBody<CreateBusinessSpaceRequestBody>;
export type GeneratedCreateBusinessSpaceResponse =
  SuccessResponse<CreateBusinessSpaceResponses>;
export type GeneratedGetBusinessSpaceResponse =
  SuccessResponse<GetBusinessSpaceResponses>;
export type GeneratedUpdateBusinessSpaceRequest =
  JsonBody<UpdateBusinessSpaceRequestBody>;
export type GeneratedUpdateBusinessSpaceResponse =
  SuccessResponse<UpdateBusinessSpaceResponses>;
export type GeneratedArchiveBusinessSpaceResponse =
  ArchiveBusinessSpaceOperation['responses'][204];
export type GeneratedRestoreBusinessSpaceResponse =
  SuccessResponse<RestoreBusinessSpaceResponses>;
export type GeneratedGetBusinessCalendarPreferencesResponse =
  SuccessResponse<GetBusinessCalendarPreferencesResponses>;
export type GeneratedUpdateBusinessCalendarPreferencesRequest =
  JsonBody<UpdateBusinessCalendarPreferencesRequestBody>;
export type GeneratedUpdateBusinessCalendarPreferencesResponse =
  SuccessResponse<UpdateBusinessCalendarPreferencesResponses>;
